import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import { FiChevronRight } from 'react-icons/fi';
import { CredusButton, CredusText, color } from 'ui';
import { BsCheckLg } from 'react-icons/bs';
import { Divider } from 'antd';
import { useMutation } from 'react-query';

import ReviewUploadTable from './tables/ReviewUploadTable';
import UploadSuccess from './modals/UploadSuccess';
import testApi from '../../../../api/test';
import { CandidateContext } from '../../../../contexts/CandidateContext';

interface BulletProps {
  color?: string;
  background?: string;
}

export interface ReviewUploadProps {
  setReviewUpload: React.Dispatch<React.SetStateAction<boolean>>;
}

const ReviewUpload = ({ setReviewUpload }: ReviewUploadProps) => {
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const { candidateData, candidateCategory } = useContext(CandidateContext);

  const { mutate } = useMutation(testApi.publishCandidates, {
    onMutate: () => setLoading(true),
    onSuccess: () => {
      setLoading(false);
      setShowSuccess(true);
    },
    onError: (error) => {
      setLoading(false);
      throw error;
    },
  });

  const handleUpload = () => {
    mutate(candidateData);
  };
  return (
    <Container>
      {showSuccess && (
        <UploadSuccess
          showSuccess={showSuccess}
          setShowSuccess={setShowSuccess}
          setReviewUpload={setReviewUpload}
        />
      )}
      <Header>
        <BulletDiv>
          <Bullet color={color.white} background={color.white}>
            <BsCheckLg color={color.primary} />
          </Bullet>
          <CredusText size="md">Upload</CredusText>
        </BulletDiv>
        <FiChevronRight color="#000929" />
        <BulletDiv>
          <Bullet background={color.primary}>
            <CredusText size="xs" color={color.white}>
              2
            </CredusText>
          </Bullet>
          <CredusText size="md">Review & Publish</CredusText>
        </BulletDiv>
      </Header>

      <SubHeader>
        <CredusText size="md">
          Exam category: <strong>{candidateCategory.category}</strong>
        </CredusText>
        <Divider
          style={{ height: '20px', background: color.lightPurple }}
          type="vertical"
        />

        <CredusText size="md">
          Period: <strong> {candidateCategory.period}</strong>
        </CredusText>
        <Divider
          type="vertical"
          style={{ height: '20px', background: color.lightPurple }}
        />
        <CredusText size="md">
          Status: <strong> In progress</strong>
        </CredusText>
      </SubHeader>
      <Body>
        <CredusText size="xl" weight="medium" style={{ marginBottom: '1rem' }}>
          Candidates
        </CredusText>
        <ReviewUploadTable candidates={candidateData.Candidates} />
        <BtnDiv>
          <CredusButton variant="secondary">Return</CredusButton>
          <CredusButton onClick={handleUpload} disabled={loading}>
            {loading ? 'Loading' : 'Upload'}
          </CredusButton>
        </BtnDiv>
      </Body>
    </Container>
  );
};

export default ReviewUpload;
const Container = styled.div`
  background: ${color.white};
  padding: 2rem 1rem;
`;
const Header = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

const BulletDiv = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

const Bullet = styled.div<BulletProps>`
  height: 28px;
  width: 28px;
  border-radius: 50%;
  border: 1px solid ${color.primary};
  background: ${(props) => props.background};
  color: ${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SubHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding-top: 3.5rem;
  width: 100%;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(0, 9, 41, 0.15);
`;

const Body = styled.div`
  padding-top: 4rem;
`;

const BtnDiv = styled.div`
  width: 100%;
  margin-top: 2rem;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`;
